import { z } from 'zod';

export interface SeedInfo {
  serverSeedHash: string;
  clientSeed: string;
  nonce: number;
  /** previous (revealed) pair, available after rotation */
  previous?: { serverSeed: string; serverSeedHash: string; clientSeed: string; lastNonce: number } | null;
}
export const zSetClientSeed = z.object({ clientSeed: z.string().min(1).max(64) });

/** Data attached to every settled bet so it can be verified on the fair page. */
export interface FairProof {
  serverSeedHash: string;
  /** null until the seed is revealed (rotation for per-user seeds, round end for shared rounds) */
  serverSeed: string | null;
  clientSeed: string;
  nonce: number;
}
